import { render } from "./ValidationForm.vue?vue&type=template&id=f9980bf8"
import script from "./ValidationForm.vue?vue&type=script&lang=js"
export * from "./ValidationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__